import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { __decorate } from "tslib";
import { createCustomizedShow, uploadFile, endProductColorList, endProductColorDetail } from '@/services/http';
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';
import { isValidPhone } from '@/tools/regexp';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.isVisible = false;
    _this.defaultValueData = null;
    //  上传图片列表
    _this.fileList = [];
    // 单色多色标签详情
    _this.detailsList = [];
    // 打印内容图片id
    _this.customizContent = '';
    //  是否已经上传最大数量图片
    _this.maxpic = false;
    _this.currentIndex = 0;
    _this.colorItem = '';
    _this.infor = {};
    // 手机号码
    _this.mobile = '';
    // 留言
    _this.remark = '';
    // colorStr
    _this.colorStr = '';
    _this.listData = [];
    _this.options = [{
      value: '选项1',
      label: '黄金糕'
    }, {
      value: '选项2',
      label: '双皮奶'
    }, {
      value: '选项3',
      label: '蚵仔煎'
    }, {
      value: '选项4',
      label: '龙须面'
    }, {
      value: '选项5',
      label: '北京烤鸭'
    }];
    _this.value = '';
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      this.getColorList();
    }
    // 上传图片
  }, {
    key: "uploadpic",
    value: function () {
      var _uploadpic = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
        var file, uploadlength, form, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              file = _toConsumableArray(event.target.files);
              if (!(this.fileList.length < 5)) {
                _context.next = 9;
                break;
              }
              uploadlength = 5 - this.fileList.length;
              form = new FormData();
              file.forEach(function (value) {
                form.append('fileData', value);
                form.append('type', '11');
              });
              _context.next = 7;
              return uploadFile(form);
            case 7:
              res = _context.sent;
              if (res.data.code === 100) {
                this.fileList = [].concat(_toConsumableArray(this.fileList), _toConsumableArray(res.data.data.slice(0, uploadlength)));
                if (this.fileList.length === 5) {
                  this.maxpic = true;
                }
                this.customizContent = this.fileList.map(function (e) {
                  return e.id;
                }).join(',');
              } else {
                this.$message.error(res.data.message);
              }
            case 9:
              // eslint-disable-next-line no-param-reassign
              event.target.value = '';
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function uploadpic(_x) {
        return _uploadpic.apply(this, arguments);
      }
      return uploadpic;
    }()
  }, {
    key: "removefile",
    value: function removefile(index) {
      this.fileList.splice(index, 1);
      this.maxpic = false;
    }
  }, {
    key: "getColorList",
    value: function () {
      var _getColorList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return endProductColorList({
                companyId: 1
              });
            case 2:
              res = _context2.sent;
              this.infor = res.data.data;
              this.colorItem = res.data.data.blankLabelName;
              this.selectColor();
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getColorList() {
        return _getColorList.apply(this, arguments);
      }
      return getColorList;
    }()
  }, {
    key: "selectTag",
    value: function selectTag(index, name) {
      this.currentIndex = index;
      this.colorItem = name;
      this.selectColor();
    }
    // 选择颜色数量
  }, {
    key: "selectColor",
    value: function () {
      var _selectColor = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res, arr;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return endProductColorDetail({
                lableType: this.currentIndex,
                companyId: 1
              });
            case 2:
              res = _context3.sent;
              if (this.currentIndex === 1) {
                arr = res.data.data.colorList.map(function (value) {
                  return {
                    label: value.id,
                    value: value.color
                  };
                });
                this.listData = arr;
              }
              this.detailsList = res.data.data.detailList;
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function selectColor() {
        return _selectColor.apply(this, arguments);
      }
      return selectColor;
    }()
  }, {
    key: "showViewer",
    value: function showViewer() {
      var viewer = this.$refs.images.$viewer;
      viewer.show();
    }
  }, {
    key: "next",
    value: function () {
      var _next = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this$$route$query, materialName, size, orderNum, packageTypeName, rowTypeName, directionTypeName, cornerTypeName, materialId, diameter;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (this.mobile === '') {
                this.$message.error('请输入手机号码');
              } else if (!isValidPhone(this.mobile)) {
                this.$message.error('请输入正确的手机号码！');
              } else {
                _this$$route$query = this.$route.query, materialName = _this$$route$query.materialName, size = _this$$route$query.size, orderNum = _this$$route$query.orderNum, packageTypeName = _this$$route$query.packageTypeName, rowTypeName = _this$$route$query.rowTypeName, directionTypeName = _this$$route$query.directionTypeName, cornerTypeName = _this$$route$query.cornerTypeName, materialId = _this$$route$query.materialId, diameter = _this$$route$query.diameter;
                createCustomizedShow({
                  mobile: this.mobile,
                  materialName: materialName,
                  size: size,
                  orderNum: orderNum,
                  packageTypeName: packageTypeName,
                  rowTypeName: rowTypeName,
                  directionTypeName: directionTypeName,
                  cornerTypeName: cornerTypeName,
                  customizContent: this.customizContent,
                  colorStr: this.colorStr,
                  remark: this.remark,
                  materialId: materialId,
                  diameter: diameter,
                  colorItem: this.colorItem,
                  companyId: 1
                });
                this.$router.push('/erial-success');
              }
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function next() {
        return _next.apply(this, arguments);
      }
      return next;
    }()
  }]);
}(Vue);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Footer: Footer,
    BackTop: BackTop
  }
})], default_1);
export default default_1;